// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WCQ8","field":"styles_field__1_aRe","fieldCol":"styles_fieldCol__46R5y","diffCol":"styles_diffCol__3C1em","diff":"styles_diff__3k5S3"};